export default {
	firstname: "Prénom",
	lastname: "Nom",
	phone: "Numéro de téléphone",
	language: "Langue",
	newsletterSubscribe: "S'abonner à la newsletter",
	newsletterSubscribed:
		"Abonné à la newsletter. Si vous le souhaitez, vous pouvez vous désabonner à nouveau lors du prochain envoi.",
	usernameEmail: "Nom d'utilisateur / E-mail",
	changeUsernameTooltip:
		"Cliquez ici pour modifier votre adresse e-mail / nom d'utilisateur. Vous définirez le nouveau nom d'utilisateur dans une boîte de dialogue.",
	changePasswordButton: "Modifier le mot de passe",
	changePasswordTooltip: "Cliquez ici pour modifier votre mot de passe.",
	appCodeLabel: "Code d'application pour le module Fusion 360 / SolidWorks",
	appCodeDescription:
		"Si vous concevez avec Autodesk Fusion 360 ou SolidWorks, nous vous recommandons d'utiliser le module Blexon. Installez le module pour {fusion} ou {solidworks} et connectez-le avec le code d'application ci-dessus à la boutique Blexon. Vous pourrez ainsi charger vos modèles CAO directement dans la boutique Blexon sans export/import.",
	appCodeSecrecy:
		"Gardez votre code d'application secret et ne le communiquez en aucun cas à des tiers. Si votre code d'application a été divulgué, générez impérativement un nouveau code.",
	copyAppCode: "Copier",
	copyAppCodeTooltip: "Copier le code dans le presse-papiers",
	regenerateAppCode: "Regénérer",
	regenerateAppCodeTooltip:
		"Cliquez ici pour générer un nouveau code. L'accès avec l'ancien code ne sera alors plus possible.",
	changeUsernameDialog: {
		title: "Modification du nom d'utilisateur",
		text: "Votre adresse e-mail est également votre nom d'utilisateur pour la connexion.",
		text2: "Si vous modifiez votre adresse e-mail, votre nom d'utilisateur changera également. Veuillez en tenir compte lors de votre prochaine connexion.",
		newUsernameLabel: "Nouveau nom d'utilisateur / E-mail",
		hint: "Remarque :",
		hintText:
			"Il ne s'agit pas de l'adresse e-mail pour l'envoi des factures. Vous la trouverez dans les paramètres de l'adresse de facturation.",
	},
	emailChangeRegisteredDialog: {
		title: "E-mail de confirmation envoyé",
		text: "Vous recevrez un e-mail de confirmation à la nouvelle adresse indiquée.",
		text2: "En cliquant sur le lien qu'il contient, la modification sera activée.",
	},
	emailChangeFailedDialog: {
		title: "Échec de la modification",
		text: "La modification n'a pas pu être effectuée.",
		text2: "Veuillez vérifier que l'adresse e-mail est correcte et valide.",
		text3: "Un compte Blexon existe peut-être déjà sous cette adresse e-mail.",
		text4: "Si vous pensez que la nouvelle adresse e-mail est valide et vous appartient, veuillez contacter notre assistance.",
	},
	changePasswordDialog: {
		title: "Modifier le mot de passe",
		text: "Nous vous enverrons un e-mail à {username}. Il contient un code et un lien vers la page où vous pourrez définir un nouveau mot de passe à l'aide du code.",
		text2: "Veuillez également vérifier votre dossier de courrier indésirable si vous ne recevez pas l'e-mail.",
	},
	messages: {
		usernameSame:
			"Le nouveau nom d'utilisateur est identique au nom actuel ou à celui déjà modifié.",
		saveSuccess: "Paramètres enregistrés avec succès.",
		saveError: "Les paramètres n'ont pas pu être enregistrés.",
		passwordChangeMailSent: "L'e-mail de modification du mot de passe a été envoyé.",
		passwordChangeMailError: "L'e-mail de modification du mot de passe n'a pas pu être envoyé.",
		appCodeCopied: "Code d'application copié avec succès dans le presse-papiers.",
		appCodeGenerateError: "Erreur lors de la génération du code d'application. Veuillez contacter notre assistance.",
	},
};
